<template>
  <div class="purchase-container" :class="{ 'disabled-container': loggedInState }">
    <Button
      :enabled="enablePaymentContainer"
      width="full"
      color="gray-800"
      text="white"
      :style="{
        '--custom-radius': '8px',
        '--custom-font-size': '14px'
      }"
      @click="subscribeClick"
    >
      <span v-if="isFreeTrialEnabled" class="free-trial-text">
        {{ $t('purchase.price.info.freeTrialButton') }}
      </span>
      <span v-else>{{ $t('purchase.price.info.buyNow') }}</span>
    </Button>

    <div class="mt-3 d-flex align-items-center">
      <img
        src="https://cdn.vexels.com/img/icons/padlock.svg"
        class="mr-2"
        :alt="$t('purchase.price.info.encryption')"
        height="18"
        width="16"
        loading="lazy"
      />
      <span class="encryption-text">{{ $t('purchase.price.info.encryption') }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Button from 'UI/Button';

export default {
  components: {
    Button
  },
  props: {
    loggedInState: {
      type: Boolean,
      required: true
    },
    activeMethod: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('plans', ['openPlan']),
    ...mapState('payments', ['freeTrialUsed', 'stripeClientSecret']),
    ...mapGetters('payments', ['getBuyNowFunction', 'getLoadingPayment']),
    enablePaymentContainer() {
      if (this.activeMethod == 'paypal') {
        return true;
      }
      // Sin client secret no hay Payment Element montado: confirmPayment fallaría.
      if (this.activeMethod == 'stripe-elements' && !this.stripeClientSecret) {
        return false;
      }
      return !this.getLoadingPayment && !this.loggedInState;
    },
    isFreeTrialEnabled() {
      return this.openPlan.hasFreeTrial && !this.freeTrialUsed;
    }
  },
  methods: {
    subscribeClick() {
      this.getBuyNowFunction();
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase-container {
  margin-top: 20px;

  .disabled-container {
    opacity: 0.25;
  }
  .encryption-text {
    font-size: 11px;
    color: #a6a6a6;
    font-weight: 500;
  }
  .contact-text {
    margin: 15px 0 20px;
    font-size: 13px;
  }
  .gray-text {
    color: #b5b5b5;
  }
  .terms-and-cond {
    font-size: 12px;
  }
}
</style>
